import { computed, Ref } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { useMetadataExperienceApi } from "@/composables/useMetadataExperienceApi";
import { useRouteParams } from "@vueuse/router";

export const EXPERIENCE_VENUES_QUERY_KEY = "experience-venues";

export function useExperienceVenuesQuery(experienceId: Ref<string>) {
  const { getVenuesById } = useMetadataExperienceApi();

  return useQuery({
    queryKey: [EXPERIENCE_VENUES_QUERY_KEY, experienceId],
    queryFn: () => getVenuesById(experienceId.value),
    select: ({ data }) => data,
    enabled: computed(() => !!experienceId.value),
  });
}

export function useCurrentExperienceVenuesQuery() {
  const experienceId = useRouteParams<string>("id");

  return useExperienceVenuesQuery(experienceId);
}
